<template>
  <div id="app" @click="everyClick">
    <!-- :class="theme" -->
    <keep-alive :include="keepAlive">
      <router-view />
    </keep-alive>

    <!-- <vue-confirm-dialog></vue-confirm-dialog> -->

    <TukLoader
      v-if="showTukLoader"
      @check="checkTukLoader"
      @hide="hideTukLoader"
      style="position: absolute; top: 0; z-index: 9999999"
    />

    <div v-show="showPageLoader" class="page-loader">
      <half-circle-spinner
        :animation-duration="1200"
        :size="190"
        color="#209CEE"
      />
    </div>

    <MainInit />

    <LanguageModal />
    <LoginSMSModal :verify="false" />
    <LoginModal :msg="loginModalMsg" />

    <div v-if="isReady">
      <MainDebug v-if="$store.getters.isSuperUser" />
      <IOSGPSModal2 />
      <ChromeGPSModal />
      <EditRoleModal />
      <RoleEditJSONModal />
      <RegionSelectModal />
      <SetAddressModal />
      <!-- currently geolocation prompt panel is not used, see geolocationRequestModal() -->
      <GeolocationPromptPanel />

      <DelinquencyNotice
        v-if="delinquencyNotice && showDelinquency"
        @close="showDelinquency = false"
      />
      <WarningNotice
        v-if="warningNotice && showWarningNotice"
        @close="showWarningNotice = false"
      />
      <ServiceNotice
        v-if="showServiceNotice"
        @close="showServiceNotice = false"
      />

      <!-- <ToursModal /> -->
      <!-- <InfoModal :msg="infoModalMsg" /> -->
      <!-- <UserAddressModal2 :addressType="addressType" :country="addressCountry" /> -->
      <!-- <IOSInstallModal2 /> -->
      <!-- <IOSGPSModal /> -->
    </div>

    <!-- TODO change group="passenger"-->
    <notifications group="foo" position="top center" width="100%" />
    <notifications group="eta" position="bottom center" />
    <notifications group="bottom" position="bottom center" />
    <notifications group="driver" />
  </div>
</template>

<script>
// import Vue100vh from "vue-div-100vh";
import { checkViewportDelay } from "@/helpers";

import EventBus from "./eventBus.js";
import { sounds } from "./functions.js";
// import manifests from "./manifests.js";

import { HalfCircleSpinner } from "epic-spinners";

import MainDebug from "@/components/MainDebug.vue";
import MainInit from "@/components/MainInit.vue";

import LoginModal from "@/components/LoginModal.vue";
// import InfoModal from "@/components/InfoModal.vue";
import LanguageModal from "@/components/LanguageModal.vue";
import LoginSMSModal from "@/components/LoginSMSModal.vue";
// import IOSInstallModal2 from "@/components/IOSInstallModal2.vue";
import IOSGPSModal2 from "@/components/IOSGPSModal2.vue";
import ChromeGPSModal from "@/components/ChromeGPSModal.vue";
import EditRoleModal from "@/components/EditRoleModal.vue";
import RoleEditJSONModal from "@/components/RoleEditJSONModal.vue";
// import ToursModal from "@/components/ToursModal.vue";
import RegionSelectModal from "@/components/RegionSelectModal.vue";
// import UserAddressModal2 from "@/components/UserAddressModal2.vue";
import SetAddressModal from "@/components/SetAddressModal.vue";
import GeolocationPromptPanel from "@/components/GeolocationPromptPanel.vue";
import TukLoader from "@/components/TukLoader.vue";
import DelinquencyNotice from "@/components/DelinquencyNotice.vue";
import WarningNotice from "@/components/WarningNotice.vue";
import ServiceNotice from "@/components/ServiceNotice.vue";

import songthaewsPic from "@/assets/songthaews_400w.jpeg";
import siilorsPic from "@/assets/siilors_400w.jpeg";
import siilorIcon from "@/assets/transport_menu_siilor.png";
import songthaewIcon from "@/assets/transport_menu_songthaew.png";
import publicTuktukIcon from "@/assets/transport_menu_tourist.png";

export default {
  components: {
    // Vue100vh,
    HalfCircleSpinner,
    // SpringSpinner,
    MainDebug,
    MainInit,
    LoginModal,
    // InfoModal,
    LanguageModal,
    LoginSMSModal,
    // IOSInstallModal,
    // IOSInstallModal2,
    IOSGPSModal2,
    ChromeGPSModal,
    EditRoleModal,
    RoleEditJSONModal,
    // ToursModal,
    RegionSelectModal,
    // UserAddressModal2,
    SetAddressModal,
    GeolocationPromptPanel,
    TukLoader,
    DelinquencyNotice,
    WarningNotice,
    ServiceNotice,
  },
  data() {
    return {
      showServiceNotice: false, // used for Songkran...
      showWarningNotice: true,
      showDelinquency: true,
      loginModalMsg: this.$t("login.please-login"), //"Please login",
      // infoModalMsg: "",
      appLoader: null,
      addressType: null,
      addressCountry: null,
      showPageLoader: false,
      loaderSize: Math.min(window.innerWidth * 0.75, window.innerHeight * 0.75),
      hiddenAt: null, // timestamp when app visibility hidden
      visibleAt: new Date(),
      isReady: false, // firstClick: true, << set isReady true after we have language and coords
      showTukLoader: false,
      keepAlive: [
        "UserInfo",
        "Issues",
        "Search",
        // "Transport",
        "TukTukDispatcher",
        "FleetDispatcher",
        "Driver",
        // "Splash", // don't need to keep this one alive... only shows once
        "Home",
        "Home2",
        "Loading",
        "Profile",
        "Shop",
        // "ShopProfile",
        // "BusinessProfile",
        "DeliveryDispatch",
        "DeliveryBatch",
        "Commerce",
        "CommerceHome",
        "CommercePage",
        "Ecommerce",
        "Payment",
        "OrderConfirmation",
        "ControlCentre",
        "CircuitBreaker",
        "CircuitBreakerBid",
        "DispatcherFleet",
        "DispatcherJobs",
        "LogisticsFleet",
        "LogisticsJobs",
        "LogisticsOrder",
        // "CommerceOrder",
        "QRLookup",
        // "ShortLink", << commented out on 24 Mar 2021, was causing issue on back nav to @ route
        // "MenuEditor", << don't keep this alive so that it pulls fresh data every time
        // "ListEditor", << don't keep alive so pulls fresh data everytime
        "Orders",
        // "Geometry", << don't keep this alive so it recenters on business each time
        "Eat",
        "Ride",
        "RideBooking",
        "ListEditor",
        "LinkShortener",
        "SuperOps",
        // "CPOrderHistory", // not working...
      ],
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme; // not being used here at the moment
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    delinquencyNotice() {
      if (!this.isLoggedIn) return;
      return this.$store.state.user.data.delinquency_notice;
    },
    warningNotice() {
      if (!this.isLoggedIn) return;
      return this.$store.state.user.data.warning_notice;
    },
  },
  errorCaptured(err) {
    console.error("ERROR CAPTURED", err);
    this.$store.dispatch("logError", {
      type: "error_captured",
      error: err.toString(),
      stack: err.stack,
      location: window.location.href,
    });
    if (err.toString().startsWith("QuotaExceededError")) {
      this.errorToast("Your localStorage is full", "top");
    }
  },
  beforeCreate() {
    this.$store.commit("initialiseStore"); // sync with localStorage whenever app is created
  },
  created() {
    this.$store.commit("setTimestamp", "appLoadedAt");

    this.$store.state.songthaewsPic = songthaewsPic;
    this.$store.state.siilorsPic = siilorsPic;
    this.$store.state.siilorIcon = siilorIcon;
    this.$store.state.songthaewIcon = songthaewIcon;
    this.$store.state.publicTuktukIcon = publicTuktukIcon;

    this.monitorVisibility(); // do these things every time app becomes visible again
  },
  // beforeMount() {
  //   const startPoint = new Date().getTime();
  //   while (new Date().getTime() - startPoint <= 5000) {
  //     /* wait */
  //   }
  // },
  mounted() {
    this.log("app_load", document.referrer);
    this.log("start_url", window.location.href); // could move to MainInit or elsewhere
    // console.log("mounted query", this.$route.query);
    this.$h.postCSSHack();
    this.checkVersion();
    this.setupPageLoader();
    this.subscribeToStore();
    this.checkDeletedOrBlockedUser();
    this.checkUserCookie(); // maybe wait and do after 5 seconds etc
    this.$store.commit("setPollingLocationBool", false); // set false initially
    this.$store.state.superUser = false; // set false initially
    if (this.$store.state.userState) {
      this.$store.state.geolocationPrompted = true; // if userState not null then geolocation had been granted
    }

    this.$store.commit("resetRouteHistory");
    this.$store.commit("updateRouteHistory", this.$route.path);

    if (window.DeviceOrientationEvent) {
      // Listen for the deviceorientation event and handle the raw data
      window.addEventListener("deviceorientation", (e) => {
        var compassHeading; // webkit for apple, alpha for android
        if (e.webkitCompassHeading) compassHeading = e.webkitCompassHeading;
        else compassHeading = e.alpha;
        this.$store.commit("setCompassHeading", compassHeading);
      });
    }

    EventBus.$on("DESTROY_APP", () => this.log("app_destroyed")); // log app destroyed

    EventBus.$on("OPEN_LOGIN_MODAL", (msg) => {
      this.log("open_login_modal");
      console.log("OPEN_LOGIN_MODAL", msg);
      this.loginModalMsg = msg;
      if (!msg) this.loginModalMsg = this.$t("login.login-to-view");
      this.$el.querySelector(".login-modal").classList.add("is-active");
    });

    EventBus.$on("OPEN_LOGIN_SMS_MODAL", (payload) => {
      var msg = null;
      if (payload) msg = payload.msg;
      this.log("open_login_sms_modal", msg);
      this.displayModal(".login-sms-modal");
    });

    // moved this from ProfileBusinessTab so can trigger from DriverMain
    EventBus.$on("EDIT_ROLE_MODAL", () => {
      this.displayModal(".edit-role-modal");
    });

    EventBus.$on("ROLE_EDIT_JSON_MODAL", () => {
      this.displayModal(".role-edit-json-modal");
    });

    EventBus.$on("OPEN_IOS_GPS_MODAL", () => {
      this.displayModal(".ios-gps-modal2");
    });

    EventBus.$on("OPEN_CHROME_GPS_MODAL", () => {
      this.displayModal(".chrome-gps-modal");
    });

    EventBus.$on("OPEN_LANGUAGE_MODAL", () => {
      this.displayModal(".language-modal");
    });

    EventBus.$on("OPEN_REGION_MODAL", () => {
      this.updateLocation();
      this.displayModal(".region-select-modal");
    });

    EventBus.$on("GO_HOME", () => this.goHome());

    EventBus.$on("UPDATE_IOS_LOCATION", (location) =>
      this.iosLocation(location)
    );

    EventBus.$on("RECEIVED_IOS_NOTIFICATION", (notification) => {
      if (notification) this.$store.commit("newNotification", notification);
    });

    EventBus.$on("LEAFLET_ROUTER_LINK", (route) => this.$router.push(route));

    EventBus.$on("SET_ADDRESS_MODAL", () => {
      this.displayModal(".set-address-modal");
    });

    EventBus.$on("GEOLOCATION_PROMPT", () => {
      this.showComponent(".geolocation-prompt-panel-component");
    });

    EventBus.$on("UPDATING_APP", () => (this.showTukLoader = true));

    window.addEventListener("beforeinstallprompt", (e) => {
      // e.preventDefault(); // prevents install mini-infobar from appearing initially
      this.$store.commit("stashPWAPrompt", e);
    });
  },
  methods: {
    onFirstClick() {
      // this.firstClick = false; // turn off so not triggered again
      this.isReady = true; // set true after we know language and gps
      this.initialiseFacebook();
      this.checkUser(); // added 13 May 2020? what for?
      this.updateAddresses(); // gets user addresses
      this.updateAllWorkflows();
      if (this.$store.getters.getUserLocation) this.updateEateries(false);
      this.longPollCustomerTransactions();
      // this.pollForMessages();
      setTimeout(() => this.updateRoles(false), 5000);

      // TODO check if user has notification token already before automatically requesting
      // if new user without token, should only ask for this later, such as in order flow
      setTimeout(() => this.requestPushNotificationPermission(), 1000 * 15);

      // delay benchmark computation 25s to let app fully load
      setTimeout(() => this.makeBenchmark(), 1000 * 25);

      setTimeout(() => this.updateUser(), 1000 * 10);

      // setTimeout(() => EventBus.$emit("OPEN_REGION_MODAL"), 2000); // test region modal
    },
    checkDeletedOrBlockedUser() {
      if (!this.$store.state.user) return;
      var user = this.$store.state.user;
      // if user.is_deleted it won't be triggered here... see checkUser() instead
      if (user.is_deleted || user.data.is_blocked) {
        // show warning and log out user
        this.errorToast("Account does not exist", "top", 99 * 1000);
        this.goto("no_such_user");
      }
      // // 3 Jan 2023: also check for delinquent user
      // if (user.data.is_delinquent) {
      //   this.infoToast("You're delinquent!!!", "top", 99 * 1000);
      // }
      // console.log("is_delinquent", user.data);
    },
    checkUserCookie() {
      // user_id in cookie
      // if logged in set cookie
      if (this.isLoggedIn) {
        this.$cookies.set("user_id", this.userID());
        return;
      }
      // else check if cookie user_id exists and automatically log in
      var cookieUserID = this.$cookies.get("user_id");
      if (cookieUserID) this.getUserInfo(cookieUserID); //this.loginUserWithCookie(cookieUserID);
    },
    getUserInfo(userID) {
      // var loader = this.loadingDots();
      this.$store
        .dispatch("getUserInfo", userID)
        .then((res) => {
          console.log("getUserInfo", res);
          // if user is_deleted should remove cookie...
          if (!res.data) return;
          if (!res.data.user) return;
          this.promptLoginUserWithCookie(res.data);
          // currently user is not being returned at all if deleted...
        })
        .catch((err) => console.error("getUserInfo", err));
      // .finally(() => loader.hide())
    },
    promptLoginUserWithCookie(userInfo) {
      // userInfo is more than just user object...also roles, userSource etc
      console.log("cookieUser", userInfo);
      var user = userInfo.user;
      // check if user is deleted or blocked first...
      if (user.is_deleted || user.data.is_blocked) return;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.1em; margin-bottom:10px'>
          👋🏼 Welcome back <b>${user.name}</b></p>
        <p style='margin-bottom:8px'>Is this still your phone number?</p>
        <p style='text-align:center'>📲 <b>${user.phone_number}</b></p>
        </div>`,
        showCancelButton: true,
        confirmButtonText: "Yes, Login as " + user.name,
        cancelButtonText: "No, Change Number",
      }).then((val) => {
        if (val.value) this.loginUserWithCookie(userInfo);
        // else // could clear cookie user_id...
      });
    },
    loginUserWithCookie(userInfo) {
      this.requestPersistedStoragePermission();
      this.infoToast("Logging In");
      console.log("loginUserWithCookie", userInfo);

      this.$store.commit("setUser", userInfo); // sets user related objects
      this.$store.commit("loginMethod", "cookie");

      // this.log("sms_login_success");
      // this.updateRoles(false); // needed to get workflows
      // if (!this.$store.getters.realName) this.setName(this.callback);
      // else if (this.callback) EventBus.$emit(this.callback);
      // else this.loginSuccessAlert();

      var loader = this.loadingDots("black");
      setTimeout(() => loader.hide(), 1000);
    },
    checkUser() {
      this.$store
        .dispatch("checkUser")
        .then((res) => {
          if (!res) return; // not logged in, no user
          console.log("checkUser", res);
          if (res.data === "user is deleted") {
            this.errorToast("Account does not exist", "top", 99 * 1000);
            this.goto("no_such_user");
          }
        })
        .catch((err) => this.apiError(err));
    },
    checkTukLoader() {
      // don't do anything for now because app will re-load itself
    },
    hideTukLoader() {
      this.showTukLoader = false;
      location.reload();
    },
    setupPageLoader() {
      this.$router.beforeEach((to, from, next) => {
        checkViewportDelay(0); // check viewport on each nav
        // console.log("beforeEach", to, from);
        // check if the next page has a new document title
        if (to.meta.title) document.title = to.meta.title;
        else document.title = "TUK App"; // otherwise reset document title
        this.showPageLoader = true;
        if (this.invalidBackRoute(to.path)) next({ name: "home" });
        else next();
      });

      this.$router.afterEach(() => {
        // (to, from, next)
        if (this.isReady) this.commitLocation(); // after first click, should use IP address coords anyway
        this.$store.commit("updateRouteHistory", this.$route.path);
        this.showPageLoader = false;
        this.log("navigation", this.$route.path);
        if (this.$route.query.a) {
          this.log("advertising", this.$route.query.a);
          var query = Object.assign({}, this.$route.query);
          delete query.a;
          this.$router.replace({ query });
        }
        // this.$router.replace({ hash: null });
      });
    },

    // check if going to /@short_link is invalid back route
    invalidBackRoute(toPath) {
      if (!toPath.includes("/@")) return false;
      var previousRoute = this.$store.getters.getPreviousRoute;
      console.log("previousRoute", previousRoute);
      if (!previousRoute) return false;
      if (previousRoute.includes("/@")) return true; // premium link
      if (previousRoute.includes("/q/")) return true; // short link
      return false;
    },

    subscribeToStore() {
      this.$store.subscribe((mutation, state) => {
        localStorage.setItem("store", JSON.stringify(state));
        if (mutation.type === "setUser") {
          this.checkDeletedOrBlockedUser();
          this.$store.dispatch("setUUID");
          this.$store.dispatch("getRideCount"); // on login get ride count
        }
        if (mutation.type === "updateUser") {
          this.checkDeletedOrBlockedUser();
        }
        if (mutation.type === "selectTukTuk") {
          this.checkTukTukRole();
        }
        if (mutation.type === "setUserState") {
          if (state.userState.distance === -1) {
            // means got location for the first time, trick for new user who just got location
            this.updateAllWorkflows();
          }
          if (state.userState.distance > 50000) {
            // if location changed by more than 50km set flag to trigger welcome to...
            if (!this.isSuperUser()) this.$store.commit("setWelcomeTo", true);
          }
        }
        if (mutation.type === "newNotification") {
          this.log("notification", state.notification);
          EventBus.$emit("UPDATE_COMMERCE_HISTORY");
          // this.checkMessages();
          this.updateOrdersCommerceAgent();
          // this.updateOrdersLogisticsAgent();
          this.updateCustomerOrders();
          console.log("newNotification", state.notification);
          var title = state.notification.title;
          var body = state.notification.body;
          if (this.$store.getters.getDispatcherRole) {
            if (body) sounds("squawk");
            this.updateOrdersFleetDispatcher();
          }
          if (this.$store.state.isWorking) {
            if (body) sounds("squawk"); // because it will squawk later if no body
            this.updateTransactionsForDriver(true);
          } else {
            this.updateTransactionsForCustomer(false);
          }
          if (title && !body) {
            var msg = title;
            var group = "foo"; // top
            var msgStyle = "chat"; // blue+gold
            if (msg[0] === ":") {
              group = "bottom";
              msgStyle = "magic"; // yellow
              msg = "🧙‍♂️ " + msg.split(":")[2];
              sounds("mystery_short");
            } else {
              msg = "🦜 " + msg;
              sounds("parrot");
            }
            this.$notify({
              group: group,
              type: msgStyle,
              title: msg,
              duration: -1,
              ignoreDuplicates: true,
            });
          }
          if (title && title[0] === ":") {
            // notification starting with colon assume it's special command
            // split on colon, first is senderID, second is command, third is parameter
            var fields = title.split(":");
            var senderID = fields[1]; // start with index 1, 0 is null
            var command = fields[2];
            var param = null;
            if (fields.length > 3) param = fields[3];
            switch (command) {
              case "ping":
                this.sendPushNotification("pong 🧙‍♂️", senderID);
                break;
              case "updateRoles":
                this.updateRoles(true);
                this.sendPushNotification("updated roles 🧙‍♂️", senderID);
                break;
              case "goto":
                this.goto(param);
                this.sendPushNotification(`goto ${param} 🧙‍♂️`, senderID);
                break;
              case "clearCache":
                this.sendPushNotification("clearing cache 🧙‍♂️", senderID);
                this.clearCacheAndReload();
                break;
              case "restart":
                this.sendPushNotification("restarting 🧙‍♂️", senderID);
                setTimeout(() => this.refreshPage(), 1800);
                break;
              case "systemStats":
                var latency = this.$store.state.systemSpeed;
                var benchmark = this.$store.state.cpuBenchmark;
                var speed = "not supported";
                if (navigator.connection) speed = navigator.connection.downlink;
                var str = `system stats: CPU ${benchmark} micro, API ${latency} ms, Download ${speed} Mbps 🧙‍♂️`;
                this.sendPushNotification(str, senderID);
                break;
              default:
                var invalid = `invalid command: ${command} 🧙‍♂️`;
                this.sendPushNotification(invalid, senderID);
            }
          }
        }
      });
    },

    monitorVisibility() {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          this.visibleAt = new Date();
          var secondsHidden = Math.round((new Date() - this.hiddenAt) / 1000);
          if (!this.hiddenAt) secondsHidden = 0;
          this.log("app_visible", secondsHidden);
          this.checkVersion();
          // this.checkMessages();
          this.updateOrdersCommerceAgent(false);
          // this.updateOrdersLogisticsAgent();
          // probably also check any driver or customer transactions too
        } else {
          this.hiddenAt = new Date();
          var secondsVisible = Math.round((new Date() - this.visibleAt) / 1000);
          this.log("app_hidden", secondsVisible);
          localStorage.setItem("store", JSON.stringify(this.$store.state));
        }
      });
    },

    initialiseFacebook() {
      // facebook login stuff
      window.fbAsyncInit = function () {
        FB.init({
          appId: "383275132369285",
          cookie: true,
          xfbml: true,
          version: "v4.0",
        });
        // FB.getLoginStatus(res => console.log("FB login status", response));
      };

      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    },

    checkTukTukRole() {
      var w = this.$store.state.selectedTukTuk;
      console.log("checktuktukrole for workflow_id:", w.id);
      var workerRole = this.$store.getters.getWorkerRoles.find((r) => {
        r.workflow_id === w.id;
      });
      if (workerRole) {
        console.log("checktuktukrole worker YAY");
        return;
      }
      var customerRole = this.$store.getters.getCustomerRoles.find(
        (r) => r.workflow_id === w.id
      );
      console.log("customerRole", customerRole);
      if (customerRole) {
        console.log("checktuktukrole customer YAY");
        return;
      }
      // if does not have worker or customer role, need to create
      if (w.data.requires_authentication) {
        this.createTukTukRoleAuth(w);
        return;
      }
      if (w.data.requires_unit_number) {
        this.createTukTukRoleUnitNumber(w);
        return;
      }
    },
    createTukTukRoleAuth(w) {
      this.$swal({
        title: "Enter Passcode",
        input: "number",
        showCancelButton: true,
        inputValidator: (val) => {
          if (!val || val.length < 4) return "Passcode is 4 digits long";
          if (val !== w.data.passcode) return "Incorrect passcode!";
        },
      }).then((val) => {
        console.log("val", val);
        if (val.value) {
          // user had correct passcode;
          if (w.data.requires_unit_number) {
            this.createTukTukRoleUnitNumber(w);
            return;
          }
          // doesn't require unit number so let them through
          this.createTukTukRole(w);
          return;
        }
        this.$store.commit("clearTukTuk"); // failed passcode so clear
        this.warningAlert("Please get passcode from the residence");
      });
    },
    createTukTukRoleUnitNumber(w) {
      this.$swal({
        title: this.$t("passenger.enter-unit-number"),
        input: "text",
        showCancelButton: false,
        inputValidator: (val) => {
          if (!val) return this.$t("passenger.unit-number-required"); //"Unit number required!";
        },
      }).then((val) => {
        console.log("unit number", val);
        if (val.value) {
          var data = { unit_number: val.value };
          this.createTukTukRole(w, data); // we have the unit number!
          return;
        }
        this.$store.commit("clearTukTuk");
        this.warningAlert(this.$t("passenger.please-unit-number")); // "Please input your unit number"
      });
    },
    createTukTukRole(w, data) {
      this.$store
        .dispatch("createRole", {
          phone_number: this.$store.getters.phoneNumber,
          business_id: w.business_id,
          workflow_id: w.id,
          workflow_name: w.name,
          role_type: "customer",
          role_name: "Passenger",
          data: data,
        })
        .then((res) => {
          this.console("createTukTukRole success", res);
          this.success();
          this.updateRoles(false);
        })
        .catch((err) => this.apiError(err));
    },
    clearNotifications() {
      this.$notify({ group: "foo", clean: true });
      this.$notify({ group: "bottom", clean: true });
    },
    everyClick() {
      // things to do on every app click
      this.clearNotifications(); // on any click clear all notifications
      if (!this.isReady) this.onFirstClick();
    },
  },
};
</script>

<style lang="scss">
:root {
  --red: #b00;
  // color: var(--red);
  --mwVH: 200px;
  // bulma colors
  --link: #3273dc;
  --info: #209cee;
  --success: #35ac5e;
  --primary: #00d1b2;
  --link: #3273dc;
  --info: #209cee;
  --warning: #ffdd57;
  --danger: #ff3860;
  --light: #f5f5f5;
  --dark: #363636;
  // --crypto-primary: #8a02c3;
  --crypto-primary: #1c37bd;
  // --crypto-secondary: #00ffbd;
  --crypto-secondary: #209cee;
  // --crypto-secondary-light: #00ffbd;
  --crypto-secondary-light: #209cee;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: whitesmoke;
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;

  /* mobile safari viewport bug fix */
  min-height: 100vh;
  min-height: -webkit-fill-available;
  height: -webkit-fill-available;
  max-height: -webkit-fill-available;
  // height: var(--mwVH);
}

// #app.dark {
//   background-color: #1f1b24;
// }
// html {
//   margin:    0 auto;
//   max-width: 400px;
// }
html,
body {
  max-height: 100vh;
  max-width: 100vw;
  height: 100vh;
  width: 100vw;
  overscroll-behavior: contain;
  // overflow: hidden;
  /* mobile safari viewport bug fix */
  // min-height: 100vh;
  // min-height: -webkit-fill-available;
  // height: -webkit-fill-available;
  // max-height: -webkit-fill-available;
  // margin: 0;
  // padding: 0;
}

body {
  /* mobile safari viewport bug fix */
  // min-height: 100vh;
  // max-height: 100vh;
  // height: 100vh;
  // min-height: -webkit-fill-available;
  // height: -webkit-fill-available;
  // max-height: -webkit-fill-available;
  //
  // -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  // -webkit-touch-callout: none;
  touch-action: manipulation;
  // background-color: whitesmoke;
}

// @media (prefers-color-scheme: dark) {
//   #app {
//     background-color: #2c3e50;
//     color: #ccc;
//   }
// }
@media (max-width: 600px) {
  /* conditional / responsive CSS inside this condition */
  /* don't allow text selection on mobile screen width */
  body {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}

// css for full screen printing, e.g. invoice
// @media print {
//   #controls,
//   .footer,
//   .footerarea {
//     display: none;
//   }
//   html,
//   body {
//     height: 100%;
//     overflow: hidden;
//     background: #fff;
//     font-size: 9.5pt;
//   }
//   .template {
//     width: auto;
//     left: 0;
//     top: 0;
//   }
//   img {
//     width: 100%;
//   }
//   li {
//     margin: 0 0 10px 20px !important;
//   }
// }

.modal-card-body {
  width: 95vw;
  margin: 0 auto;
  border-radius: 5px;
  max-height: 80vh;
}

button.modal-close {
  background-color: #187fe7;
  // background-color: #44a4fc;
}

button.modal-close.is-large {
  filter: drop-shadow(1px 1px 2px black);
}

.page-loader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999999;
}

.vue-notification {
  max-width: 600px;
  padding: 10px;
  margin: 8px;
  border-radius: 5px;
  box-shadow: 1px 1px 0.5px 0.5px #444;

  font-size: 14px;
  font-size: 1.6em;
  text-shadow: 0.5px 0.5px 1px black;

  color: #ffffff;
  background: #44a4fc;
  border-left: 5px solid #187fe7;

  &.magic {
    background: #ffb648;
    border-left-color: #f48a06;
    font-size: 1.5em;
    color: black;
  }

  &.warn {
    background: #ffb648;
    border-left-color: #f48a06;
  }

  &.error {
    background: #e54d42;
    border-left-color: #b82e24;
  }

  &.success {
    background: #68cd86;
    border-left-color: #42a85f;
  }

  &.chat {
    background: rgba(164, 249, 255, 1);
    border-left-color: gold;
    font-size: 1.6em;
    color: hsl(217, 71%, 53%);
    // .notification-title
  }
}

// global leaflet styling
.leaflet-container {
  // default map loading color is grey
  background: rgba(255, 217, 0, 0.5) !important;
}

.leaflet-marker-icon.leaflet-div-icon {
  height: 0px;
  width: 0px;
}

.awesome-marker i {
  font-size: 16px;
  margin-top: 8px;
}

.awesome-marker i.fa-lg {
  font-size: 18px;
  margin-top: 12px;
}

// Vue-SVGIcon styling
.svg-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  color: inherit;
  vertical-align: middle;
  fill: none;
  stroke: currentColor;
}

.svg-fill {
  fill: currentColor;
  stroke: none;
}

.svg-up {
  /* default */
  transform: rotate(0deg);
}

.svg-right {
  transform: rotate(90deg);
}

.svg-down {
  transform: rotate(180deg);
}

.svg-left {
  transform: rotate(-90deg);
}

.wiggle:active {
  transform: rotate(330deg);
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
  display: none;
}

.has-text-orange {
  color: orange;
}

.is-orange {
  background-color: orange;
}

.gpu-accelerated {
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

// google location / place search styling
.pac-container,
.pac-item-query {
  font-size: 1.7em;
}

.pac-item {
  padding: 4px 4px;
}

.notices .toast-warning {
  background-color: #ffdd57 !important;
  // background-color: #ffae57 !important;
  color: slategrey !important;
}

.is-pointer {
  cursor: pointer;
}

.link {
  border-bottom: 1px #ccc dotted;
  cursor: pointer;
}

.rtl {
  direction: rtl;
  text-align: right;
  margin-right: 6px;
}

.monospace {
  font-family: Lucida Console, monospace;
}

@media print {
  #app {
    background-color: green;
    margin: 0;
    padding: 0;
  }

  html,
  body {
    background: #000;
    color: #fff;
    margin: 0;
    padding: 0;
  }
}
</style>
